"use client";

import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { firebaseConfig } from "./config";

function initializeFirebaseClientApp() {
  if (getApps().length === 0) {
    return initializeApp(firebaseConfig, "client");
  } else {
    return getApp("client");
  }
}

export const firebaseApp = initializeFirebaseClientApp();
export const auth = getAuth(firebaseApp);

export function getCurrentUser() {
  if (typeof window !== "undefined") {
    return auth.currentUser;
  }
  throw new Error("getCurrentUser must be called the client");
}
